var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlowchart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 16 16",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 10H7a1 1 0 00-1 1v4a1 1 0 001 1h8a1 1 0 001-1v-4a1 1 0 00-1-1zM5 12H2V6h3V4H2V1a1 1 0 00-2 0v12a1 1 0 001 1h4zM15 2H7a1 1 0 00-1 1v4a1 1 0 001 1h8a1 1 0 001-1V3a1 1 0 00-1-1z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjY0IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHdpZHRoPSI2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Im0xNSAxMGgtOGMtLjU1MiAwLTEgLjQ0OC0xIDF2MSAyIDFjMCAuNTUyLjQ0OCAxIDEgMWg4Yy41NTIgMCAxLS40NDggMS0xdi00YzAtLjU1Mi0uNDQ4LTEtMS0xeiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZD0ibTUgMTJoLTN2LTZoM3YtMmgtM3YtM2MwLS41NTItLjQ0OC0xLTEtMXMtMSAuNDQ4LTEgMXYxMmMwIC41NTMuNDQ4IDEgMSAxaDR6Ii8+PHBhdGggZD0ibTE1IDJoLThjLS41NTIgMC0xIC40NDgtMSAxdjEgMiAxYzAgLjU1Mi40NDggMSAxIDFoOGMuNTUyIDAgMS0uNDQ4IDEtMXYtNGMwLS41NTItLjQ0OC0xLTEtMXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvZz48L3N2Zz4K";
export { SvgFlowchart as ReactComponent };